// extracted by mini-css-extract-plugin
export default {"header":"Mobile_HeaderComponent_header__OtoGW","row":"Mobile_HeaderComponent_row__2b0ju","btn":"Mobile_HeaderComponent_btn__+7oEN"};